import { ISportsCountries } from "interfaces/sports/ISportsCountries";
import { ReduxRootState } from "model/Redux";
import ReduxStoreInterface from "model/ReduxStoreInterface";
import { Selector } from "react-redux";

export const sportsCountriesSelector: Selector<ReduxStoreInterface, ReduxRootState<ISportsCountries[]>> = state => state.sportsCountries;
export const isSportsCountriesSelectorLoading: Selector<ReduxStoreInterface, boolean> = state => state.sportsCountries.loading;
